var _defs, _g, _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPertiga(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.942,
    height: 77.035,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "234.029 36.482 31.942 77.035",
    style: {
      background: "0 0"
    },
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing-rainbow-gradient",
    x1: 0.526,
    x2: 0.474,
    y1: 0.001,
    y2: 0.999,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ff4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ff4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#72bf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#f90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f90"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "editing-rainbow",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    operator: "dilate",
    radius: "1,0.1",
    in: "SourceGraphic",
    result: "dilate"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "dilate",
    result: "color",
    values: "0.7 0 0 0 0 0 0.7 0 0 0 0 0 0.7 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1,
    result: "offset"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "blur",
    values: "0.7 0 0 0 0 0 0.7 0 0 0 0 0 0.7 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offset"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#editing-rainbow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.17 6.11v-32.94H5.6V6.11H3.17z",
    fill: "url(#editing-rainbow-gradient)",
    transform: "translate(245.615 91.47)"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPertiga);
export default __webpack_public_path__ + "static/media/pertiga.9f05644a97d396951960a1cdfa745c87.svg";
export { ForwardRef as ReactComponent };